// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "soc" + "." + "159a4bf0140e2af94521" + ".css";
};